import { asDynamicTraversable as ObjectToTraversable } from './traverse-object.js';
import { asDynamicTraversable as TreeNodeToTraversable } from './tree-mutable.js';
export * as Mutable from './tree-mutable.js';
export * as Pathed from './pathed.js';
export * as FromObject from './traverse-object.js';
export * as Traverse from './traversable-tree.js';
export * from './compare.js';
export const toTraversable = (node) => {
    if (isTraversable(node))
        return node;
    if (isTreeNode(node))
        return TreeNodeToTraversable(node);
    if (typeof node === `object`)
        return ObjectToTraversable(node);
    throw new Error(`Parameter 'node' not convertible`);
};
export const isTreeNode = (node) => {
    if (`parent` in node && `childrenStore` in node && `value` in node) {
        if (Array.isArray(node.childrenStore))
            return true;
    }
    return false;
};
export const isTraversable = (node) => {
    return (`children` in node && `getParent` in node && `getValue` in node && `getIdentity` in node);
};
